module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('center', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.departmentLoader == true) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.departmentLoader == false) ? _c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Details")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Form Messaging")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Tabs")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Form")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Calculator Links")]), _vm._v(" "), _c('v-tab', {
    key: 6,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Starting Rules")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Name",
      "single-line": "",
      "required": "",
      "rules": _vm.nameRules,
      "solo": ""
    },
    model: {
      value: (_vm.processName),
      callback: function($$v) {
        _vm.processName = $$v
      },
      expression: "processName"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Name of the service form")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Department:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "label": "Process Department",
      "item-value": "id",
      "item-text": "name",
      "required": "",
      "rules": _vm.departmentRules,
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.processDepartment),
      callback: function($$v) {
        _vm.processDepartment = $$v
      },
      expression: "processDepartment"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Department the service form belongs to")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Process Token:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Token",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.processToken),
      callback: function($$v) {
        _vm.processToken = $$v
      },
      expression: "processToken"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Token linked to the service form")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Onsite Visit Article Ticket Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Onsite Visit Article Name",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.processHsArticleName),
      callback: function($$v) {
        _vm.processHsArticleName = $$v
      },
      expression: "processHsArticleName"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("The onsite visit article ticket name")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Onsite Visit Article Ticket Number:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Onsite Visit Article Number",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.processHsArticleNumber),
      callback: function($$v) {
        _vm.processHsArticleNumber = $$v
      },
      expression: "processHsArticleNumber"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("The onsite visit article ticket number")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Onsite Visit Article Ticket Price:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Onsite Visit Article Price",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.processHsArticlePrice),
      callback: function($$v) {
        _vm.processHsArticlePrice = $$v
      },
      expression: "processHsArticlePrice"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("The onsite visit article ticket price")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Process Roles To Display:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.userRoles,
      "item-value": "id",
      "item-text": "name",
      "label": "Process User Roles",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.processRoles),
      callback: function($$v) {
        _vm.processRoles = $$v
      },
      expression: "processRoles"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Show user roles that should be linked to this service form quotes")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Checkout Branch:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.branchList,
      "item-value": "code",
      "item-text": "name",
      "label": "Checkout Branch",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.checkoutBranch),
      callback: function($$v) {
        _vm.checkoutBranch = $$v
      },
      expression: "checkoutBranch"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "smallDescription"
  }, [_vm._v("Select if checkout is for specific branch")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Waiver Callout Fee For Commercial Clients:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Waiver fee for commercial clients"
    },
    model: {
      value: (_vm.overrideCallout),
      callback: function($$v) {
        _vm.overrideCallout = $$v
      },
      expression: "overrideCallout"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Contact Customer Message:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Contact Me Message",
      "multi-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.popupContact),
      callback: function($$v) {
        _vm.popupContact = $$v
      },
      expression: "popupContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Request Quote Message:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Quote Request Message",
      "multi-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.popupRequest),
      callback: function($$v) {
        _vm.popupRequest = $$v
      },
      expression: "popupRequest"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Request Measure to Quote Message:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Onsite Visit Message",
      "multi-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.popupVisit),
      callback: function($$v) {
        _vm.popupVisit = $$v
      },
      expression: "popupVisit"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Request Measure to Quote Message - Payment Required:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Request Measure to Quote - Payment Required",
      "multi-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.popupPayment),
      callback: function($$v) {
        _vm.popupPayment = $$v
      },
      expression: "popupPayment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Calculator Message:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Calculator Message",
      "multi-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.popupCalculator),
      callback: function($$v) {
        _vm.popupCalculator = $$v
      },
      expression: "popupCalculator"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('p', [_vm._v("Setup the dynamic tabs that will be displayed in your Service Form.")])]), _vm._v(" "), (_vm.showAdd == true) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Tab Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tab Name",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd == true) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Show Client:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Show tab to client"
    },
    model: {
      value: (_vm.tabClient),
      callback: function($$v) {
        _vm.tabClient = $$v
      },
      expression: "tabClient"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd == true) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Show For Which Service Types:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tabForValues,
      "label": "Select the service types that apply to this tab",
      "item-value": "id",
      "item-text": "text",
      "required": "",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.tabFor),
      callback: function($$v) {
        _vm.tabFor = $$v
      },
      expression: "tabFor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd == true) ? _c('v-flex', {
    attrs: {
      "lg11": ""
    }
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.showAdd == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "right": "30px"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddTab()
      }
    }
  }, [_vm._v("Save Tab")])], 1) : _vm._e(), _vm._v(" "), (_vm.showEdit == true) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Tab Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Tab Name",
      "single-line": "",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.editTabName),
      callback: function($$v) {
        _vm.editTabName = $$v
      },
      expression: "editTabName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showEdit == true) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Show For Which Service Types:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.tabForValues,
      "label": "Select the type of tab",
      "item-value": "id",
      "item-text": "text",
      "required": "",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.editTabFor),
      callback: function($$v) {
        _vm.editTabFor = $$v
      },
      expression: "editTabFor"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showEdit == true) ? _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Show Client:")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Show tab to client"
    },
    model: {
      value: (_vm.editTabClient),
      callback: function($$v) {
        _vm.editTabClient = $$v
      },
      expression: "editTabClient"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showEdit == true) ? _c('v-flex', {
    attrs: {
      "lg11": ""
    }
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.showEdit == true) ? _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "right": "30px"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateTab()
      }
    }
  }, [_vm._v("Update Tab")])], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd == false && _vm.showEdit == false) ? _c('v-flex', {
    staticStyle: {
      "margin-top": "-30px"
    },
    attrs: {
      "lg11": ""
    }
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.showAdd == false && _vm.showEdit == false) ? _c('v-flex', {
    staticStyle: {
      "margin-top": "-30px"
    },
    attrs: {
      "lg1": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "right": "17px"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowAdd()
      }
    }
  }, [_vm._v("Create Tab")])], 1) : _vm._e(), _vm._v(" "), (_vm.showAdd == false && _vm.showEdit == false) ? _c('v-data-table', {
    ref: "sortableTable",
    staticClass: "elevation-1 processTabs",
    attrs: {
      "loading": "true",
      "headers": _vm.tabHeaders,
      "items": _vm.processTabs,
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          staticClass: "px-1",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "35%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetYesNo(props.item.is_client)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncShowEdit(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteTab(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])])]
      }
    }], null, false, 2438256437)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('p', [_vm._v("Setup the dynamic form fields for the dynamic tabs that will be displayed in your Service Form.")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Tab:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.processTabs,
      "label": "Select the tab you want to add form fields to",
      "item-value": "id",
      "item-text": "name",
      "required": "",
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.currentFormTab),
      callback: function($$v) {
        _vm.currentFormTab = $$v
      },
      expression: "currentFormTab"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg5": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Input Type:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.columnType,
      "label": "Select input type",
      "item-value": "id",
      "item-text": "text",
      "required": "",
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.currentFormColumn),
      callback: function($$v) {
        _vm.currentFormColumn = $$v
      },
      expression: "currentFormColumn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg1": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v(" ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddColumn()
      }
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), _vm._l((this.processTabForms[this.currentFormTab]), function(tabInfo, index) {
    return _c('v-flex', {
      attrs: {
        "lg12": ""
      }
    }, [(tabInfo.type == 'input') ? _c('div', {
      staticStyle: {
        "background": "#EFEFEF",
        "float": "left",
        "clear": "both",
        "width": "100%",
        "padding-bottom": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding-left": "20px",
        "width": "48.5%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Input Label:")]), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "label": "Input Label",
        "single-line": "",
        "required": "",
        "solo": ""
      },
      on: {
        "input": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].label),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "label", $$v)
        },
        expression: "processTabForms[currentFormTab][index].label"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "48.5%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Required:")]), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Is the input a required field"
      },
      on: {
        "change": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].required),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "required", $$v)
        },
        expression: "processTabForms[currentFormTab][index].required"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3%",
        "float": "left",
        "padding-top": "12px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.fncDeleteFormItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])]) : _vm._e(), _vm._v(" "), (tabInfo.type == 'select') ? _c('div', {
      staticStyle: {
        "background": "#EFEFEF",
        "float": "left",
        "clear": "both",
        "width": "100%",
        "padding-bottom": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding-left": "20px",
        "width": "32.33%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Input Label:")]), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "label": "Input Label",
        "single-line": "",
        "required": "",
        "solo": ""
      },
      on: {
        "input": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].label),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "label", $$v)
        },
        expression: "processTabForms[currentFormTab][index].label"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-left": "20px",
        "width": "32.33%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Dropdown Values:")]), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "label": "Dropdown Values",
        "single-line": "",
        "required": "",
        "solo": ""
      },
      on: {
        "input": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].values),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "values", $$v)
        },
        expression: "processTabForms[currentFormTab][index].values"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "32.33%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Required:")]), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Is the input a required field"
      },
      on: {
        "change": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].required),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "required", $$v)
        },
        expression: "processTabForms[currentFormTab][index].required"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3%",
        "float": "left",
        "padding-top": "12px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.fncDeleteFormItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])]) : _vm._e(), _vm._v(" "), (tabInfo.type == 'yesno') ? _c('div', {
      staticStyle: {
        "background": "#EFEFEF",
        "float": "left",
        "clear": "both",
        "width": "100%",
        "padding-bottom": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding-left": "20px",
        "width": "48.5%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Input Label:")]), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "label": "Input Label",
        "single-line": "",
        "required": "",
        "solo": ""
      },
      on: {
        "input": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].label),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "label", $$v)
        },
        expression: "processTabForms[currentFormTab][index].label"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "48.5%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Required:")]), _vm._v(" "), _c('v-switch', {
      attrs: {
        "label": "Is the input a required field"
      },
      on: {
        "change": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].required),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "required", $$v)
        },
        expression: "processTabForms[currentFormTab][index].required"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3%",
        "float": "left",
        "padding-top": "12px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.fncDeleteFormItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])]) : _vm._e(), _vm._v(" "), (tabInfo.type == 'header') ? _c('div', {
      staticStyle: {
        "background": "#EFEFEF",
        "float": "left",
        "clear": "both",
        "width": "100%",
        "padding-bottom": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding-left": "20px",
        "width": "97%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('p', [_vm._v("Header Title:")]), _vm._v(" "), _c('v-text-field', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "placeholder": "Header Label",
        "single-line": "",
        "required": "",
        "solo": ""
      },
      on: {
        "input": function($event) {
          return _vm.fncResetState()
        }
      },
      model: {
        value: (_vm.processTabForms[_vm.currentFormTab][index].label),
        callback: function($$v) {
          _vm.$set(_vm.processTabForms[_vm.currentFormTab][index], "label", $$v)
        },
        expression: "processTabForms[currentFormTab][index].label"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3%",
        "float": "left",
        "padding-top": "12px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.fncDeleteFormItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])]) : _vm._e(), _vm._v(" "), (tabInfo.type == 'break') ? _c('div', {
      staticStyle: {
        "background": "#EFEFEF",
        "float": "left",
        "clear": "both",
        "width": "100%",
        "padding-bottom": "16px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding-left": "20px",
        "width": "97%",
        "float": "left",
        "padding-top": "20px"
      }
    }, [_c('h3', [_vm._v("BREAK")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3%",
        "float": "left",
        "padding-top": "12px"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.fncDeleteFormItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])]) : _vm._e()])
  })], 2)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 repLinkTable",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "headers": _vm.calcHeaders,
      "items": _vm.calculatorLinks,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "40%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Calculator Name",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.name),
            callback: function($$v) {
              _vm.$set(props.item, "name", $$v)
            },
            expression: "props.item.name"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Calculator Link",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.link),
            callback: function($$v) {
              _vm.$set(props.item, "link", $$v)
            },
            expression: "props.item.link"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-btn', {
          staticClass: "text-xs-right",
          staticStyle: {
            "margin-top": "2% !important",
            "float": "right",
            "background": "#333",
            "color": "#fff",
            "margin-right": "1.5% !important"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.fncDeleteRow(props)
            }
          }
        }, [_vm._v("Delete Row")])], 1)]
      }
    }], null, false, 1899603852)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "margin-top": "2% !important",
      "float": "right",
      "background": "#333",
      "color": "#fff",
      "margin-right": "1.5% !important"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddRow()
      }
    }
  }, [_vm._v("Add Calculator Row")])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 6,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n                Customer Service Form\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.serviceType,
      "label": "Service Type",
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.startingRulesCustomer),
      callback: function($$v) {
        _vm.startingRulesCustomer = $$v
      },
      expression: "startingRulesCustomer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n                Selected Roles Service Form\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.userRoles,
      "label": "Roles",
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.startingRulesRoles),
      callback: function($$v) {
        _vm.startingRulesRoles = $$v
      },
      expression: "startingRulesRoles"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.serviceType,
      "label": "Service Type",
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.startingRulesSet),
      callback: function($$v) {
        _vm.startingRulesSet = $$v
      },
      expression: "startingRulesSet"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n                Other Service Form ( This will apply for circumstances not covered by the above )\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.serviceType,
      "label": "Service Type",
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.startingRulesOther),
      callback: function($$v) {
        _vm.startingRulesOther = $$v
      },
      expression: "startingRulesOther"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddProcess()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed.")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}